import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { displayRecurrentSubsidy } from "../displays/allowance/display-recurrent-subsidy";
import { resetAllowanceMemory } from "../../../infrastructure/allowance-config-repository";
import { translate as t } from "../../../infrastructure/translate/localization";

import "./information-section.scss";

export default class InformationSection extends Component {
  constructor(props) {
    super(props);
    this.state = { recurrent: false };
  }

  handleCancel = () => {
    window.location.href = "/benefits";
    resetAllowanceMemory();
  };

  handleSubmit = () => {
    const { model, alertId } = this.props;
    const { recurrent } = this.state;
    displayRecurrentSubsidy({
      message: t("subsidy-section.subsidy-delivery-sure"),
      model,
      isRecurrent: recurrent,
      alertId,
    });
  };

  render() {
    const { availableAmount, totalAmount, model } = this.props;
    const { recurrent } = this.state;
    return (
      <div className="information-section">
        <p className="title-section">{t("subsidy-section.summary-subsidy")}</p>
        {!model.subsidy && (
          <div className="cob-btn-group">
            <div
              className="cob-checkbox"
              onClick={() => this.setState({ recurrent: !recurrent })}
              role="presentation"
            >
              {recurrent && <FontAwesomeIcon icon="check" />}
            </div>
            <p>{t("subsidy-section.want-schedule-subsidy")}</p>
          </div>
        )}

        <div className="cob-btn-group right-group">
          <div className="checked">
            <div className="amount total-amount">
              <span>{t("subsidy-section.total-subsidy")}</span>
              <span className="line-dotted" />
              <span>
                {new Intl.NumberFormat("es-ES", {
                  style: "currency",
                  currency: "EUR",
                }).format(totalAmount)}
              </span>
            </div>
            <div className="amount available-amount">
              <span>{t("subsidy-section.balance-after-delivery")}</span>
              <span className="line-dotted" />
              <span>
                {new Intl.NumberFormat("es-ES", {
                  style: "currency",
                  currency: "EUR",
                }).format(availableAmount)}
              </span>
            </div>
          </div>
        </div>

        <div className="cob-btn-group right-group">
          <button type="button" className="cob-btn" onClick={this.handleCancel}>
            {t("actions.cancel")}
          </button>
          <button
            type="button"
            className="cob-btn btn-primary"
            disabled={availableAmount < 0 || totalAmount === 0}
            onClick={this.handleSubmit}
          >
            {t("subsidy-section.subsidy-delivery")}
          </button>
        </div>
      </div>
    );
  }
}

InformationSection.defaultProps = { alertId: null };
InformationSection.propTypes = {
  availableAmount: PropTypes.number.isRequired,
  totalAmount: PropTypes.number.isRequired,
  model: PropTypes.object.isRequired,
  alertId: PropTypes.string,
};
